<template>
  <v-hover>
    <template #default="{ isHovering, props: hoverProps }">
      <v-card
        :color="isHovering ? 'grey-lighten-5' : 'white'"
        border
        v-bind="hoverProps">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="label d-flex align-center ga-1">
                <v-icon
                  color="grey-darken-1"
                  icon="mdi-calendar-blank-outline"
                  size="small"></v-icon>
                Дата врегулювання
              </div>
              <b-input-date
                v-model="form.resolvedDate"
                :error-messages="getErrorMessages(v$.resolvedDate)"
                hide-details
                @blur="v$.resolvedDate.$touch()"></b-input-date>
            </v-col>

            <v-col cols="12">
              <div class="label d-flex align-center ga-1">
                <v-icon
                  color="grey-darken-1"
                  icon="mdi-tools"
                  size="small"></v-icon>
                Механізм врегулювання
              </div>
              <b-textarea
                v-model="form.resolutionMethod"
                :error-messages="getErrorMessages(v$.resolutionMethod)"
                hide-details
                placeholder="Опишіть конкретні дії, що були вжиті для врегулювання інциденту..."
                rows="4"
                @blur="v$.resolutionMethod.$touch()"></b-textarea>
            </v-col>

            <v-col cols="12">
              <div class="label d-flex align-center ga-1">
                <v-icon
                  color="grey-darken-1"
                  icon="mdi-currency-usd"
                  size="small"></v-icon>
                Сума можливих збитків після врегулювання, грн
              </div>
              <b-input-number
                v-model="form.damageCostAfterResolution"
                :error-messages="getErrorMessages(v$.damageCostAfterResolution)"
                hide-details
                rank-spacing
                @blur="v$.damageCostAfterResolution.$touch()">
              </b-input-number>
              <div class="text-medium-emphasis mt-2">
                Загальні можливі втрати до врегулювання:
                {{ rankSpacing(totalDamageCostPotential) }} грн
              </div>
            </v-col>

            <v-col cols="12">
              <div class="label d-flex align-center ga-1">
                <v-icon
                  color="grey-darken-1"
                  icon="mdi-clock-outline"
                  size="small"></v-icon>
                Що потрібно покращити в бізнес-процесі
              </div>
              <b-textarea
                v-model="form.processImprovements"
                :error-messages="getErrorMessages(v$.processImprovements)"
                hide-details
                placeholder="Опишіть покращення процесу та контролів..."
                rows="4"
                @blur="v$.processImprovements.$touch()"></b-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </v-hover>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue'
import { BInputDate, BInputNumber, BTextarea } from 'best-modules/components'
import { CustomDate, getErrorMessages, rankSpacing } from 'best-modules/utils'
import { minValue, required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { Dialog } from '@/dialog'
import type { IncidentResolutionCredentials } from '@/utils/types/incident'

export default {
  name: 'IncidentResolution',
  components: {
    BInputDate,
    BInputNumber,
    BTextarea,
  },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: {
    getErrorMessages,
    rankSpacing,
  },
  setup(props) {
    const totalDamageCostPotential = props.dialog.dialogData
      .totalDamageCostPotential as number
    const incidentId = props.dialog.dialogData.incidentId as number

    const form = reactive<IncidentResolutionCredentials>({
      incidentId,
      resolvedDate: new CustomDate(new Date()).toString({ format: 'iso' }),
      resolutionMethod: null,
      damageCostAfterResolution: null,
      processImprovements: null,
    })

    const rules = {
      incidentId: { required },
      resolvedDate: { required },
      resolutionMethod: { required },
      damageCostAfterResolution: { required, minValue: minValue(0) },
      processImprovements: { required },
    }

    const v$ = useVuelidate(rules, form)

    const submit = () => {
      return { ...form }
    }

    return { form, submit, totalDamageCostPotential, v$ }
  },
}
</script>
